import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { notificar } from '../utils/notify';
import '../styles/Atrasoatual.css';

const Atrasoatual = () => {
  const [empresas, setEmpresas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [mensagem, setMensagem] = useState('');
  useEffect(() => { notificar(mensagem); }, [mensagem]);
  const [dadosUsuario, setDadosUsuario] = useState(null);
  const [carregandoAcesso, setCarregandoAcesso] = useState(true);
  const [acessoNegado, setAcessoNegado] = useState(false);
  
  // Estados para o modal de observação
  const [mostrarModal, setMostrarModal] = useState(false);
  const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
  const [observacao, setObservacao] = useState('');
  const [salvando, setSalvando] = useState(false);

  // Filtros
  const [filtros, setFiltros] = useState({
    empresa: '',
    numero_dominio: '',
    regime: '',
    dias_atraso_min: '',
    status_observacao: '' // 'todos', 'com_obs', 'sem_obs'
  });

  // Verificar acesso
  const verificarAcesso = useCallback(async () => {
    setCarregandoAcesso(true);
    const accessToken = localStorage.getItem('access');

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/verificar-grupo/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (response.data.success) {
        const { usuario, first_name, grupo, name } = response.data;
        
        setDadosUsuario({
          username: usuario,
          first_name: first_name,
          grupo: grupo,
          name: name
        });

        if (grupo === 'rh') {
          setAcessoNegado(true);
        } else {
          setAcessoNegado(false);
        }
      } else {
        setAcessoNegado(true);
      }
    } catch (error) {
      console.error('Erro ao verificar acesso:', error);
      setAcessoNegado(true);
    } finally {
      setCarregandoAcesso(false);
    }
  }, []);

  useEffect(() => {
    verificarAcesso();
  }, [verificarAcesso]);

  // Determinar username
  let username = 'usuário';
  if (dadosUsuario) {
    username = dadosUsuario.name || 
               dadosUsuario.first_name || 
               dadosUsuario.username || 
               'usuário';
  }

  // Carregar empresas
  const carregarEmpresas = useCallback(() => {
    if (!username || username === 'usuário') return;
    
    setCarregando(true);
    setMensagem('');
    const accessToken = localStorage.getItem('access');

    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/listar-empresas-atraso-10-dias/`, {
        params: { operador: username },
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        setEmpresas(res.data.empresas || []);
        setCarregando(false);
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.erro || error.message || 'Erro ao carregar empresas';
        setMensagem(`Erro: ${errorMsg}`);
        setCarregando(false);
      });
  }, [username]);

  useEffect(() => {
    if (!acessoNegado && !carregandoAcesso && username !== 'usuário') {
      carregarEmpresas();
    }
  }, [carregarEmpresas, acessoNegado, carregandoAcesso, username]);

  // Abrir modal para cadastrar observação
  const abrirModalObservacao = (empresa) => {
    setEmpresaSelecionada(empresa);
    setObservacao(empresa.observacao || '');
    setMostrarModal(true);
  };

  // Salvar observação
// Salvar observação
const salvarObservacao = async () => {
  if (!observacao.trim()) {
    setMensagem('Por favor, preencha a observação');
    return;
  }

  try {
    setSalvando(true);
    const accessToken = localStorage.getItem('access');
    
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE}/api/cadastrar-observacao-atraso/`,
      {
        numero_dominio: empresaSelecionada.numero_dominio,
        empresa: empresaSelecionada.empresa,
        operador: empresaSelecionada.operador,
        dias_atraso: empresaSelecionada.dias_atraso,
        competencia: empresaSelecionada.competencia, // ENVIAR COMPETÊNCIA
        observacao: observacao.trim()
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    if (response.data.success) {
      const acao = response.data.acao === 'atualizado' ? 'atualizada' : 'cadastrada';
      setMensagem(`Observação ${acao} com sucesso!`);
      setMostrarModal(false);
      carregarEmpresas();
    }
    
    setSalvando(false);
  } catch (error) {
    setMensagem(`${error.response?.data?.mensagem || 'Erro ao salvar observação'}`);
    setSalvando(false);
  }
};

  // Filtrar empresas
  const empresasFiltradas = empresas.filter((emp) => {
    if (filtros.empresa && !emp.empresa.toLowerCase().includes(filtros.empresa.toLowerCase())) {
      return false;
    }
    if (filtros.numero_dominio && !emp.numero_dominio.toString().includes(filtros.numero_dominio)) {
      return false;
    }
    if (filtros.regime && !emp.regime?.toLowerCase().includes(filtros.regime.toLowerCase())) {
      return false;
    }
    if (filtros.dias_atraso_min && emp.dias_atraso < parseInt(filtros.dias_atraso_min)) {
      return false;
    }
    if (filtros.status_observacao === 'com_obs' && !emp.observacao) {
      return false;
    }
    if (filtros.status_observacao === 'sem_obs' && emp.observacao) {
      return false;
    }
    return true;
  });

  // Loading
  if (carregandoAcesso) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary mb-3"></div>
        <p className="text-muted">Verificando permissões...</p>
      </div>
    );
  }

  // Acesso negado
  if (acessoNegado) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-danger">
          <i className="fas fa-lock fa-3x mb-3"></i>
          <h2>Acesso Negado</h2>
          <p>Você não tem permissão para acessar esta área.</p>
          <button className="btn btn-primary mt-3" onClick={() => window.location.href = '/home'}>
            <i className="fas fa-home me-2"></i>
            Voltar para Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="atraso-atual-page">
      <div className="container mt-4">
        {/* Cabeçalho */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="titulo-pagina mb-1">
              <i className="fas fa-exclamation-triangle header-icon me-2"></i>
              Empresas com Inadimplência
            </h2>
            <p className="text-muted mb-0">
              <i className="fas fa-user me-2"></i>
              Operador: <strong>{username}</strong>
            </p>
          </div>
          <button 
            className="btn btn-secondary"
            onClick={() => window.location.href = '/contabilidade'}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
        </div>

        {/* Mensagens agora são exibidas como toast (react-toastify) */}

        {/* Filtros */}
        <div className="card mb-3">
          <div className="card-body">
            <h6 className="card-title mb-3">
              <i className="fas fa-filter me-2"></i>
              Filtros
            </h6>
            <div className="row g-3">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Filtrar por empresa..."
                  value={filtros.empresa}
                  onChange={(e) => setFiltros(prev => ({ ...prev, empresa: e.target.value }))}
                />
              </div>
              <div className="col-md-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nº Domínio..."
                  value={filtros.numero_dominio}
                  onChange={(e) => setFiltros(prev => ({ ...prev, numero_dominio: e.target.value }))}
                />
              </div>
              <div className="col-md-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Regime..."
                  value={filtros.regime}
                  onChange={(e) => setFiltros(prev => ({ ...prev, regime: e.target.value }))}
                />
              </div>
              <div className="col-md-2">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Mín. dias atraso..."
                  value={filtros.dias_atraso_min}
                  onChange={(e) => setFiltros(prev => ({ ...prev, dias_atraso_min: e.target.value }))}
                />
              </div>
              <div className="col-md-3">
                <select
                  className="form-select"
                  value={filtros.status_observacao}
                  onChange={(e) => setFiltros(prev => ({ ...prev, status_observacao: e.target.value }))}
                >
                  <option value="">Todos os status</option>
                  <option value="sem_obs">Sem observação</option>
                  <option value="com_obs">Com observação</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Tabela */}
        <div className="card">
          <div className="card-body">
            {carregando ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary mb-3"></div>
                <p className="text-muted">Carregando empresas...</p>
              </div>
            ) : empresasFiltradas.length === 0 ? (
              <div className="text-center py-5">
                <i className="fas fa-check-circle fa-3x text-success mb-3"></i>
                <h5>Parabéns!</h5>
                <p className="text-muted">Nenhuma empresa com mais de 10 dias de atraso encontrada.</p>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table table-hover table-striped align-middle">
                    <thead className="table-danger">
                    <tr>
                        <th><i className="fas fa-barcode me-2"></i>Nº Domínio</th>
                        <th><i className="fas fa-building me-2"></i>Empresa</th>
                        <th><i className="fas fa-book me-2"></i>Regime</th>
                        <th><i className="fas fa-calendar-check me-2"></i>Competência</th> {/* NOVA COLUNA */}
                        <th><i className="fas fa-calendar me-2"></i>Última Entrega</th>
                        <th><i className="fas fa-calendar-times me-2"></i>Próxima Entrega</th>
                        <th><i className="fas fa-clock me-2"></i>Dias Atraso</th>
                        <th><i className="fas fa-comment me-2"></i>Observação</th>
                        <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    {empresasFiltradas.map((empresa) => (
                        <tr key={`${empresa.numero_dominio}-${empresa.competencia}`}> {/* KEY ÚNICA */}
                        <td><code>{empresa.numero_dominio}</code></td>
                        <td className="fw-bold">{empresa.empresa}</td>
                        <td><span className="badge bg-info">{empresa.regime || '-'}</span></td>
                        <td> {/* MOSTRAR COMPETÊNCIA */}
                            <span className="badge bg-primary">
                            {empresa.competencia || '-'}
                            </span>
                        </td>
                        <td>{empresa.ultima_entrega || '-'}</td>
                        <td>{empresa.proxima_entrega}</td>
                        <td>
                            <span className="badge bg-danger fs-6">
                            {empresa.dias_atraso} dias
                            </span>
                        </td>
                        <td>
                            {empresa.observacao ? (
                            <div>
                                <span className="badge bg-success mb-1">Com observação</span>
                                <br />
                                <small className="text-muted">{empresa.data_observacao}</small>
                            </div>
                            ) : (
                            <span className="badge bg-warning text-dark">Sem justificativa</span>
                            )}
                        </td>
                        <td>
                            <button
                            className="btn btn-sm btn-warning"
                            onClick={() => abrirModalObservacao(empresa)}
                            >
                            <i className="fas fa-edit me-1"></i>
                            {empresa.observacao ? 'Editar' : 'Adicionar'}
                            </button>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-3 text-end">
                  <span className="text-muted">
                    Total: <strong>{empresasFiltradas.length}</strong> empresa(s) com atraso crítico
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Modal de Observação */}
      {mostrarModal && (
        <div className="modal" tabIndex="-1" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-comment-medical me-2"></i>
                  {empresaSelecionada?.observacao ? 'Editar Observação' : 'Adicionar Observação'}
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setMostrarModal(false)}
                  disabled={salvando}
                ></button>
              </div>
                <div className="modal-body">
                <div className="alert alert-info mb-3">
                    <strong><i className="fas fa-building me-2"></i>{empresaSelecionada?.empresa}</strong>
                    <br />
                    <small>
                    <i className="fas fa-barcode me-2"></i>Domínio: {empresaSelecionada?.numero_dominio}
                    <br />
                    <i className="fas fa-calendar-check me-2"></i>Competência: <strong className="text-primary">{empresaSelecionada?.competencia}</strong> {/* COMPETÊNCIA */}
                    <br />
                    <i className="fas fa-clock me-2"></i>Dias em atraso: <strong className="text-danger">{empresaSelecionada?.dias_atraso} dias</strong>
                    </small>
                </div>

                <div className="mb-3">
                    <label className="form-label fw-bold">
                    <i className="fas fa-comment-dots me-2"></i>
                    Justificativa do Atraso <span className="text-danger">*</span>
                    </label>
                    <textarea
                    className="form-control"
                    rows="6"
                    value={observacao}
                    onChange={(e) => setObservacao(e.target.value)}
                    placeholder="Descreva o motivo do atraso (ex: cliente não enviou documentos, problemas técnicos, aguardando informações...)"
                    disabled={salvando}
                    maxLength="1000"
                    />
                    <small className="text-muted">{observacao.length}/1000 caracteres</small>
                </div>
                </div>
              <div className="modal-footer">
                <button 
                  className="btn btn-secondary" 
                  onClick={() => setMostrarModal(false)}
                  disabled={salvando}
                >
                  Cancelar
                </button>
                <button 
                  className="btn btn-warning"
                  onClick={salvarObservacao}
                  disabled={salvando || !observacao.trim()}
                >
                  {salvando ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Salvando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save me-2"></i>
                      Salvar Observação
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Atrasoatual;